class KeyNode {
    constructor(key, value, freq = 1) {
        this.key = key
        this.value = value
        this.freq = freq
        this.prev = this.next = null
    }
}

class FreqNode {
    constructor(freq, prev, next) {
        this.freq = freq
        this.prev = prev
        this.next = next
        this.first = this.last = null
    }
}

const LFUCacheStorageKey = 'LFUCacheStorage'
const LFUCacheStorageAlreadyClearKey = 'LFUCacheStorageAlreadyClear'
const DATA_VERSION = "1"    // 当前使用的数据结构版本号

export default class LFUCache {
    constructor(capacity, { washoutTriggerRatio = 0.9, washoutTargetRatio = 0.6, onRemove } = {}) {
        this.capacity = capacity
        this.used = 0
        this.keyMap = {}
        this.freqMap = {}
        this.head = null
        
        this.washoutTriggerRatio = washoutTriggerRatio
        this.washoutTargetRatio = washoutTargetRatio
        this.onRemove = onRemove

        this.dataVer = DATA_VERSION;    // 数据结构版本号 用于判断数据结构是否有变化
        this.createVer = GAME_VERSION;  // 创建版本号 没有实质意义，单纯用于标记cache是在哪个版本的代码包下创建的，以备后续使用
    }

    // saveToStorage() {
    //     let freqMap = {}
    //     for (let key in this.freqMap) {
    //         let freqNode = this.freqMap[key]
    //         let freqNodeData = []
    //         let pNode = freqNode.first
    //         while (pNode) {
    //             let nodeData = {
    //                 key: pNode.key,
    //                 value: pNode.value
    //             }
    //             freqNodeData.push(nodeData)
    //             pNode = pNode.next
    //         }
    //         freqMap[key] = freqNodeData
    //     }
    //     let data = {
    //         capacity: this.capacity,
    //         used: this.used,
    //         data: freqMap
    //     }
    //     localStorage.setItem(LFUCacheStorageKey, JSON.stringify(data))
    // }

    saveToStorage() {
        let nodes = []
        // for (let key in this.keyMap) {
        //     let keyNode = this.keyMap[key]
        //     let nodeData = {
        //         key: keyNode.key,
        //         value: keyNode.value,
        //         freq: keyNode.freq,
        //     }
        //     nodes.push(nodeData)
        // }

        for (let key in this.freqMap) {
            let freqNode = this.freqMap[key]
            let pNode = freqNode.first
            while (pNode) {
                let nodeData = {
                    key: pNode.key,
                    value: pNode.value,
                    freq: pNode.freq
                }
                nodes.push(nodeData)
                pNode = pNode.next
            }
        }

        let data = {
            capacity: this.capacity,
            used: this.used,
            data: nodes,
            dataVer: this.dataVer,
            createVer: this.createVer
        }
        try {
            localStorage.setItem(LFUCacheStorageKey, JSON.stringify(data));
        } catch(e) {  
            console.warn("LFUCache saveToStorage failed.", e);   
            window.logCenter && window.logCenter.error("LFUCache saveToStorage failed.", 'LFUCache', 0, 0, e);
        }
    }

    // saveToStorageAsync() {
    //     let nodes = []
    //     for (let key in this.freqMap) {
    //         let freqNode = this.freqMap[key]
    //         let pNode = freqNode.first
    //         while (pNode) {
    //             let nodeData = {
    //                 key: pNode.key,
    //                 value: pNode.value,
    //                 freq: pNode.freq
    //             }
    //             nodes.push(nodeData)
    //             pNode = pNode.next
    //         }
    //     }

    //     let data = {
    //         capacity: this.capacity,
    //         used: this.used,
    //         data: nodes,
    //         dataVer: this.dataVer,
    //         createVer: this.createVer
    //     }

    //     return new Promise((resolve, reject) => {
    //         localStorage.setItemAsync(
    //             LFUCacheStorageKey,
    //             JSON.stringify(data),
    //             ()=>{
    //                 resolve()
    //             }
    //         )
    //     })
    // }

    readFromStorage(CACHE_MAX_CAPACITY) {
        let dataStr = null;
        try {
            dataStr = localStorage.getItem(LFUCacheStorageKey);
        } catch(e) {            
            console.warn("LFUCache readFromStorage failed.", e);   
            window.logCenter && window.logCenter.error("LFUCache readFromStorage failed.", 'LFUCache', 0, 0, e);
        }
        if (dataStr) {
            let data = JSON.parse(dataStr)
            if (typeof(data) == "string"){
                data = JSON.parse(data);
            }

            data = this.checkClear(data)
            
            this.used = data.used
            if (CACHE_MAX_CAPACITY){
                this.capacity = CACHE_MAX_CAPACITY
            }else{
                this.capacity = data.capacity
            }
            this.dataVer = data.dataVer || "0"
            this.createVer = data.createVer || ""
            let nodes = data.data
            nodes.forEach(node => this.insertKeyNode(node.key, node.value, node.freq))
        }
       return this
    }

    get(key) {
        let keyNode = this.keyMap[key]
        if (keyNode) {
            let value = keyNode.value
            this.increase(key, value)
            // 不再自动存储以提升性能，需手动调用
            // this.saveToStorage()
            return value.value
        } else {
            return null
        }
    }

    set(key, value, size) {
        if (this.capacity <= 0 || size > this.capacity * this.washoutTargetRatio) {
            console.warn(`LFU - set: ${key} is too big, ${size}, ignored`)
            return
        }
        if (this.washout(size) == -1){
            console.warn(`LFU - set: cannot washout recent, ignored`)
            return
        }
        let keyNode = this.keyMap[key]
        if (keyNode) {
            this.used = this.used - keyNode.value.size + size
            let time = Localhost.timeInSec()
            this.increase(key, {
                value,
                size,
                time
            })
            // 不再自动存储以提升性能，需手动调用
            // this.saveToStorage()
            // return
        } else {
            this.used += size
            let time = Localhost.timeInSec()
            this.insertKeyNode(key, {
                value,
                size,
                time
            })
            // 不再自动存储以提升性能，需手动调用
            // TODO: 可能出现不一致
            // this.saveToStorage()
        }
    }

    // setAsync(key, value, size) {
    //     if (this.capacity <= 0 || size > this.capacity * this.washoutTargetRatio) {
    //         console.warn(`LFU - set: ${key} is too big, ${size}, ignored`)
    //         return Promise.resolve();
    //     }

    //     return new Promise((resolve, reject)=>{
    //         this.washout(size)
    //         let keyNode = this.keyMap[key]
    //         if (keyNode) {
    //             this.used = this.used - keyNode.value.size + size
    //             this.increase(key, {
    //                 value,
    //                 size
    //             })
    //             this.saveToStorageAsync().then(()=>{
    //                 resolve()
    //             }).catch(resolve)
    //         } else {
    //             this.used += size
    //             this.insertKeyNode(key, {
    //                 value,
    //                 size
    //             })
    //             resolve()
    //         }
    //     })
    // }

    has (key) {
        return !!this.keyMap[key]
    }

    clear() {
        this.used = 0
        this.keyMap = {}
        this.freqMap = {}
        this.dataVer = DATA_VERSION
        this.createVer = GAME_VERSION
        this.head = null
        this.saveToStorage()
        //this.saveToStorageAsync().then(()=>{})
    }

    washout(increaseSize = 0) {
        let needWash = false
        if (this.used + increaseSize > this.capacity * this.washoutTriggerRatio) {
            needWash = true
        }
        console.log("LFU used="+this.used+" increaseSize="+increaseSize+" capacity*washoutTriggerRatio="+(this.capacity * this.washoutTriggerRatio)+" needWash="+needWash)
        if (needWash && this.head && this.head.first && this.head.first.value && (this.head.first.value.time || 0) + 120 > Localhost.timeInSec()){
            console.log("LFU head time="+this.head.first.value.time+" now="+Localhost.timeInSec())
            return -1
        }
        if (needWash) {
            console.log('LFU - trigger washout')
            while (this.used + increaseSize > this.capacity * this.washoutTargetRatio && this.head) {
                this.removeKeyNode(this.head.last)
            }
        }
        return 1
    }

    forceWashoutAll() {
        console.log('LFU - trigger forceWashoutAll')
        while (this.used > 0 && this.head) {
            this.removeKeyNode(this.head.last)
        }
    }

    remove(key) {
        let keyNode = this.keyMap[key]
        if (keyNode) {
            this.removeKeyNode(keyNode)
        }
    }
    
    increase(key, value) {
        let keyNode = this.keyMap[key]
        keyNode.value = value
        let freqNode = this.freqMap[keyNode.freq]
        let nextFreqNode = freqNode.next
        keyNode.freq += 1
        // console.log("LFU increase key="+key+" freq="+keyNode.freq)
        if (!nextFreqNode || nextFreqNode.freq > keyNode.freq) {
            nextFreqNode = this.insertFreqNodeAfter(keyNode.freq, freqNode)
        }
        this.unlinkNode(keyNode, freqNode)
        this.linkNode(keyNode, nextFreqNode)
    }

    insertKeyNode(key, value, freq = 1) {
        let keyNode = (this.keyMap[key] = new KeyNode(key, value, freq))
        let freqNode = this.freqMap[freq]
        if (!freqNode) {
            freqNode = this.freqMap[freq] = this.insertFreqNode(freq)
        }
        this.linkNode(keyNode, freqNode)
    }

    removeKeyNode(keyNode) {
        this.unlinkNode(keyNode, this.freqMap[keyNode.freq])
        let key = keyNode.key
        this.used -= keyNode.value.size
        this.onRemove && this.onRemove(key, keyNode.value)
        delete this.keyMap[key]
    }

    insertFreqNode(freq) {
        if (this.freqMap[freq]) {
            return this.freqMap[freq]
        } else {
            if (this.head) {
                if (this.head.freq >= freq) {
                    return this.insertFreqNodeBefore(freq, this.head)
                } else {
                    let curr = this.head
                    while (curr.freq < freq && curr.next) {
                        curr = curr.next
                    }
                    if (curr.next) {
                        return this.insertFreqNodeBefore(freq, curr)
                    } else {
                        return this.insertFreqNodeAfter(freq, curr)
                    }
                }
            } else {
                let node = new FreqNode(freq, null, null)
                this.head = node
                return node
            }
        }
    }

    insertFreqNodeBefore(freq, targetNode) {
        let node = new FreqNode(freq, targetNode.prev, targetNode)
        this.freqMap[freq] = node
        if (targetNode === this.head) {
            this.head = node
        }
        if (targetNode.prev) {
            targetNode.prev.next = node
        }
        targetNode.prev = node
        return node
    }

    insertFreqNodeAfter(freq, targetNode) {
        let node = new FreqNode(freq, targetNode, targetNode.next)
        this.freqMap[freq] = node
        if (targetNode.next) {
            targetNode.next.prev = node
        }
        targetNode.next = node
        return node
    }

    removeFreqNode(freqNode) {
        let [prev, next] = [freqNode.prev, freqNode.next]
        if (prev) {
            prev.next = next
        }
        if (next) {
            next.prev = prev
        }
        if (this.head === freqNode) {
            this.head = next
        }
        delete this.freqMap[freqNode.freq]
    }

    unlinkNode(keyNode, freqNode) {
        let [prev, next] = [keyNode.prev, keyNode.next]
        if (prev) {
            prev.next = next
        }
        if (next) {
            next.prev = prev
        }
        if (freqNode.first === keyNode) {
            freqNode.first = next
        }
        if (freqNode.last === keyNode) {
            freqNode.last = prev
        }
        if (!freqNode.first) {
            this.removeFreqNode(freqNode)
        }
    }

    linkNode(keyNode, freqNode) {
        let firstKeyNode = freqNode.first
        keyNode.prev = null
        keyNode.next = firstKeyNode
        if (firstKeyNode) {
            firstKeyNode.prev = keyNode
        }
        freqNode.first = keyNode
        if (!freqNode.last) {
            freqNode.last = keyNode
        }
    }

    /**
     * 是否需要升级
     */
    needUpdate() {
        let oldVer = this.dataVer || "0"
        if (oldVer != DATA_VERSION) {
            return true;
        } else {
            return false;
        }
    }
    /**
     * 是否需要清空
     */
    checkClear(data) {
        try {
            let cacheData = data["data"]
            let cacheLength = cacheData.length
            let savedFileList = wxDownloader.getSavedFileList()
            let savedFileLength = savedFileList.length
            console.log("[lfu] cacheLength="+cacheLength)
            console.log("[lfu] savedFileLength="+savedFileLength)
            // 清理cacheData里存在但是实际savedFile没有的，基本都是头像
            for (let i = cacheLength-1; i >= 0 ; i--) {
                let key = cacheData[i]["key"]
                let match = false
                for (let name of savedFileList){
                    if (name == key){
                        match = true
                    }
                }
                if (match == false){
                    console.log("[lfu] need clear "+key)
                    cacheData.splice(i, 1)
                }
            }
            cacheLength = cacheData.length
            let flag = cc.UserDefault.getInstance().getBoolForKey(LFUCacheStorageAlreadyClearKey, false)
            if (flag == false){
                // 启动时的全部清理只执行一次
                if (Math.abs(cacheLength - savedFileLength) >= 10){
                    wxDownloader.cleanAllAssets(this, cacheLength, savedFileLength);
                    cc.UserDefault.getInstance().setBoolForKey(LFUCacheStorageAlreadyClearKey, true)
                }
            }
        } catch(e) {            
            // Toast.make("cleancache error")
            console.log("cleancache checkClear error ",e)
        }
        return data
    }
}
